
import { defineComponent, PropType } from 'vue';
import {getQueryString} from '@activity-business/h5-package-frameworkTool';

export default defineComponent({
    name: "loading",
    props:{
        config:{
            type: Object as PropType<DevelopToolShare.LoadingConfig>,
            default: ()=>({
                visible: false
            } as DevelopToolShare.LoadingConfig)
        }
    },
    computed:{
        logSrc(){
            const version = getQueryString('initLoadVersion');
            const lang = getQueryString('lang') || 'US';
            // v1版本删除下面链接中的/v2即可！
            return `${DOMAIN.H5_IMAGE_DOMAIN}/public/loading.png${version ? '?='+version: ''}`;
        }
    }
});
